require('./createChoreFinalStep.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');

// @ commons
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const WizardError = require('components/commons/wizardError/wizardError');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @ constants
const { DATE_FORMAT_ES } = require('constants/index');

//@ utilities
const { getCurrencySymbol, getFormattedString } = require('utilities/currencyHelper');
const dateHelper = require('utilities/dateHelper');

class CreateChoreFinalStep extends React.Component {
    constructor(props) {
        super(props);

        this.buildSuccess = this.buildSuccess.bind(this);
        this.buildError = this.buildError.bind(this);
        this.createList = this.createList.bind(this);
    }

    createList(list){
        const listClassName = `create-chore-final-step__list-item col-xs-${list[3].key === '' ? '6' : '4'}`;
        return list.map((data, index) => {
            if(data.key){
                return (
                    <OKInformativeListItem
                        bodyText={data.key}
                        bodyWordBreak={false}
                        key={index}
                        title={data.title}
                        className={listClassName}
                    />
                );
            }
        })
    }

    buildError() {
        const { immCard } = this.props;
        const cardId = immCard.get('cardId');
        const errorTitle = formatText('createChoreFinalStep-errorTitle');
        const goBackButtonLabel = formatText('createChoreFinalStep-backToCard').toUpperCase();
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const mainButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        return (
            <WizardError
                errorMessage={errorTitle}
                mainButton={mainButton}
            >
                <section className="modify-money-final-step__content row">
                    <div className="col-xs-5 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="large" />
                    </div>
                    <div className="col-xs-7 col-md-7">
                        <p className="modify-money-final-step__error-message">
                            <FormattedText value="createChoreFinalStep-errorMessage" />
                        </p>
                    </div>
                </section>
            </WizardError>
        );
    }

    buildSuccess() {
        const { immOpenYoungCardCreateChore, immCard } = this.props;
        const cardId = immCard.get('cardId');
        const chore = formatText(`openYoungCardChores-task${immOpenYoungCardCreateChore.getIn(['choreType',0,'choreId'])}`);
        const currency = getCurrencySymbol(immCard.get('availableBalance'));
        const amount = [
            getFormattedString({ amount: immOpenYoungCardCreateChore.get('amount'), currency })
        ];
        const selectedEndDate = dateHelper.buildFormattedDate(
            immOpenYoungCardCreateChore.get('selectedEndDate'),
            DATE_FORMAT_ES
        );
        const concept = immOpenYoungCardCreateChore.get('concept');
        const selectedRepetitionType = immOpenYoungCardCreateChore.getIn(['selectedRepetitionType','value']);
        const goBackButtonLabel = formatText('createChoreFinalStep-backToCard').toUpperCase();
        const linkToDetails = `/myprofile/cards/${cardId}/movements`;
        const successTitle = formatText('createChoreFinalStep-successTitle');
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        };

        const list = [
            {
                key: chore,
                title: formatText('createChoreStep-chore')
            },
            {
                key: amount,
                title: formatText('createChoreStep-amount')
            },
            {
                key: selectedEndDate,
                title: formatText('createChoreStep-selectedEndDate')
            },
            {
                key: selectedRepetitionType,
                title: formatText('createChoreStep-repetitions')
            },
            {
                key: concept,
                title: formatText('createChoreStep-concept')
            },
        ];

        return (
            <WizardSuccess
                successMessage={successTitle}
                mainButton={goBackButton}>
                <section className="create-chore-final-step__content row">
                    <div className="col-xs-4 col-md-5">
                        <CommercialAds path="cards" type="cards" immCard={immCard} size="large" />
                    </div>
                    <div className="create-chore-final-step__modified-field">
                        <OKInformativeList columns={2}>
                            {this.createList(list)}
                        </OKInformativeList>
                    </div>
                </section>
            </WizardSuccess>
        );
    }

    render() {
        let finalBlock = this.props.errorState ? this.buildError() : this.buildSuccess();

        return (
            <article className="create-chore-final-step">
                {finalBlock}
            </article>
        )
    }
}

CreateChoreFinalStep.propTypes = {
    errorState: PropTypes.bool.isRequired,
    immOpenYoungCardCreateChore: PropTypes.object.isRequired,
    immCard: PropTypes.object.isRequired
};

module.exports = CreateChoreFinalStep;
